import { Expose } from 'class-transformer';
import { IsString } from 'class-validator';

export class LaundryCategory {
  @IsString()
  readonly id: string;

  @IsString()
  readonly description: string;

  @IsString()
  readonly label: string;

  @Expose({ name: 'image_url' })
  readonly imageUrl: string;

  constructor(init?: Partial<LaundryCategory> | LaundryCategory) {
    this.id = init?.id!;
    this.description = init?.description!;
    this.label = init?.label!;
    this.imageUrl = init?.imageUrl!;
  }
}

export default LaundryCategory;
